/**
 * PWA Lockbox onboarding overlay coordination.
 * Prevents stacking the guest welcome ticket, guided tour, and How to Play modal.
 */

import { isGuestWelcomeTicketDismissed } from './guestWelcomeTicketStorage';
import { isOnboardingCompleted } from './onboardingStorage';

/** Guest welcome ticket may auto-show on first /app visit. */
export function shouldAutoShowGuestWelcome({
  entered,
  authReady,
  onAppEntryRoute,
  isGuest,
}) {
  return (
    entered
    && authReady
    && onAppEntryRoute
    && isGuest
    && !isGuestWelcomeTicketDismissed()
  );
}

/**
 * Guided tour auto-show must wait until the guest welcome ticket is dismissed
 * so both overlays never stack on mobile PWA.
 */
export function shouldDeferTourAutoShow({ isGuest }) {
  if (!isGuest) return false;
  return !isGuestWelcomeTicketDismissed();
}

/** Only one full-screen onboarding layer at a time. */
export function guestWelcomeVisible({ showGuestWelcome, showTour }) {
  return Boolean(showGuestWelcome && !showTour);
}

export function howToPlayVisible({ showHowToPlay, showTour }) {
  return Boolean(showHowToPlay && !showTour);
}

/** After guest dismisses the welcome ticket, chain into the guided tour once. */
export function shouldChainTourAfterGuestWelcomeDismiss({ isGuest }) {
  return isGuest && !isOnboardingCompleted(null, { isGuest: true });
}
